import { useState, useEffect } from "react"
import { useGlobalContext } from "../../data/GlobalContext"
import { formatDate } from "./TransactionHistory"

export default function BetHistory230() {
  const { fetch230BetHistory, username } = useGlobalContext()

  // Compute today's date in "YYYY-MM-DD" format.
  const today = new Date().toISOString().split("T")[0]

  // Initialize state variables.
  const [fromDate, setFromDate] = useState(today)
  const [toDate, setToDate] = useState(today)
  const [betHistory, setBetHistory] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  // Fetch bet history data.
  const handleFilter = async () => {
    if (!username) {
      alert("Username is missing.")
      return
    }
    try {
      const report = await fetch230BetHistory(username, fromDate, toDate)
      setBetHistory(report)
      // Reset to the first page when new data is fetched.
      setCurrentPage(1)
    } catch (error) {
      console.error("Error fetching summary report:", error)
    }
  }

  // Compute indexes for slicing data for the current page.
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentBetHistory = betHistory.slice(indexOfFirstItem, indexOfLastItem)

  // Calculate total pages.
  const totalPages = Math.ceil(betHistory.length / itemsPerPage)

  // Handlers for prev and next buttons.
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1)
    }
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1)
    }
  }

  // Auto-load data when username becomes available.
  useEffect(() => {
    if (username) {
      handleFilter()
    }
  }, [username, fromDate, toDate])

  return (
    <div className="game-report-container">
      <div className="transaction-report-tools">
        <div className="transaction-report-datepicker">
          <label>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="data-datepicker"
          />
        </div>
        <div className="transaction-report-datepicker">
          <label>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="data-datepicker"
          />
        </div>
        <button
          onClick={handleFilter}
          className="transaction-report-filter-btn"
        >
          Continue
        </button>
      </div>

      <div className="bet-2-30-report-wrapper">
        <div className="bet-history-table">
          <div className="bet-history-head">
            <div>Bet Time</div>
            <div>Transaction ID</div>
            <div>Bet Amount</div>
            <div>Bet Status</div>
            <div>Number 1</div>
            <div>Number 2</div>
          </div>
          <div className="bet-history-body">
            {currentBetHistory.length > 0 ? (
              currentBetHistory.map((tx, index) => (
                <div key={index} className="bet-history-results">
                  <div>{formatDate(tx.betTime) || "-"}</div>
                  <div>{tx.transactionId || "-"}</div>
                  <div>{tx.betAmount || "-"}</div>
                  <div>{tx.betStatus || "-"}</div>
                  <div>{tx.number1 || "-"}</div>
                  <div>{tx.number2 || "-"}</div>
                </div>
              ))
            ) : (
              <div className="game-report-error-message">
                No data available for the selected period.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Pagination Controls */}
      {betHistory.length > itemsPerPage && (
        <div className="pagination">
          <button onClick={handlePrevPage} disabled={currentPage === 1}>
            Prev
          </button>
          <div>
            Page {currentPage} of {totalPages}
          </div>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {fromDate === "" && toDate === "" && (
        <div className="game-report-disclaimer-message">
          ( Data's from about a week ago—pick a date to see more )
        </div>
      )}
    </div>
  )
}
